import React from 'react';
import { Switch } from 'antd';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import { FormSection, FormLabel, FormInput, FormGrid } from '../styles';

interface FormStatusProps {
  formData: any;
  onFormChange: (field: string, value: any) => void;
}

const FormStatus: React.FC<FormStatusProps> = ({ formData, onFormChange }) => {
  return (
    <FormSection>
      <FormGrid columns={2}>
        <div>
          <FormLabel>{TEMPLATE_FORM_CONSTANTS.LABELS.STATUS}</FormLabel>
          <FormInput
            as="select"
            value={formData.status}
            onChange={(e) => onFormChange('status', e.target.value)}
          >
            <option value="DRAFT">Draft</option>
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
          </FormInput>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '12px',
            paddingBottom: '8px',
          }}
        >
          <FormLabel style={{ marginBottom: 0 }}>{TEMPLATE_FORM_CONSTANTS.LABELS.SET_AS_DEFAULT}</FormLabel>
          <Switch
            checked={formData.isDefault}
            onChange={(checked) => onFormChange('isDefault', checked)}
          />
        </div>
      </FormGrid>
    </FormSection>
  );
};

export default FormStatus;
